import { FormattedMessage } from 'react-intl'
import { Link } from 'solito/link'

import Avatar from 'app/components/base/Avatar'
import Button from 'app/components/base/Button'
import LinearGradientBorderContainer from 'app/components/base/LinearGradientBorderContainer'
import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'
import ChipLabel from 'app/components/common/ChipLabel'
import LinkUserStore from 'app/components/common/LinkUserStore'
import UserRating from 'app/components/common/UserRating'
import useAppStore from 'app/store/app.store'
import { IS_NATIVE_APP } from 'app/utils/constants/env.constants'

import { useContactSeller } from '../hooks/useContactSeller'
import useVerifyAuth from '../hooks/useVerifyAuth'

interface ContactSellerProps {
  avatar?: string
  name?: string
  rating?: number
  role?: string
  chatId?: string
  sellerSlug?: string
  isOwner?: boolean
}

const ContactSeller: RFC<ContactSellerProps> = ({
  avatar,
  name,
  rating = 0,
  role,
  chatId,
  sellerSlug,
  isOwner
}) => {
  const checkAuth = useVerifyAuth()
  const isTablet = useAppStore((state) => state.isTablet)

  const { chipText, contactSellerHandler } = useContactSeller({
    chatId,
    isOwner,
    role
  })

  return (
    <LinearGradientBorderContainer
      borderRadius={1.25}
      spacing={2}
      sx={{
        maxWidth: { xs: '100%', md: isTablet ? '100%' : 375 },
        mt: { md: 0, xs: 3 },
        mb: { md: 0, xs: 4 }
      }}
      sxContent={{
        alignSelf: 'center',
        backgroundColor: 'background.lightGreen'
      }}
    >
      <Stack direction="row" spacing={1}>
        <Link
          href={`/store/${sellerSlug}/products`}
          aria-label="seller-store-link"
        >
          <Avatar
            width={24}
            height={24}
            sizes="64px"
            src={avatar}
            {...(IS_NATIVE_APP && { layout: 'fill' })}
          />
        </Link>

        <Stack sx={{ flex: 1 }}>
          <LinkUserStore slug={sellerSlug} lineClamp={1}>
            {name}
          </LinkUserStore>
        </Stack>

        <UserRating rating={rating} type="secondary" />

        <ChipLabel sx={{ px: 1, justifyContent: 'center' }}>
          <Text variant="subtitle2" component="p" sx={{ fontWeight: 500 }}>
            {chipText}
          </Text>
        </ChipLabel>
      </Stack>

      <Button
        variant="contained"
        size="small"
        disabled={!chatId}
        onClick={() => checkAuth(() => contactSellerHandler())}
      >
        <FormattedMessage defaultMessage="Contact Seller" />
      </Button>
    </LinearGradientBorderContainer>
  )
}

export default ContactSeller
